export default __webpack_public_path__ + "static/restaurant-jupiter-0f22fdf773504e8db87a8e90da7ce7dd.jpg";